import { render } from "./Profile.vue?vue&type=template&id=c4c718d0"
import script from "./Profile.vue?vue&type=script&lang=ts"
export * from "./Profile.vue?vue&type=script&lang=ts"

import "./Profile.vue?vue&type=style&index=0&id=c4c718d0&lang=scss"
script.render = render

export default script